module.exports = __webpack_public_path__ + "media/src/images/icons/icons8-worker-1-1-9d20070d6391991b84fdc4c4c50c90a9.png";